import { IconButton, Grid, Tooltip, useTheme, Box, Typography, useMediaQuery } from "@mui/material";
import { Info } from "@mui/icons-material";
import { BetboardRow } from "../../../types/types";
import {getPopperProps} from "../../../utils/constants";
import {GameInfoToolTipRow} from "./components/GameInfoToolTipRow";

export const GameInfoToolTip = ({ game }: { game: BetboardRow }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const formattedStringTitle =
        `${game.team} ${game.line || ''} vs ${game.oTeam}${game.total ? ` (${game.total})` : ''}`
    let rest = ''
    if (game.rest?.toString() === '0') rest = `no rest`
    if (game.rest?.toString() === '1') rest = `${game.rest} day rest`
    if (+game.rest > 1) rest = `${game.rest} days rest`
    let oRest = ''
    if (game.oRest?.toString() === '0') oRest = `no rest`
    if (game.oRest?.toString() === '1') oRest = `${game.oRest} day rest`
    if (+game.oRest > 1) oRest = `${game.oRest} days rest`
    const assistToTurnover = game?.avgAssistToTurnover ? (
        <GameInfoToolTipRow
            teamValue={game.avgAssistToTurnover?.toFixed(2)}
            oppValue={game.avgOAssistToTurnover?.toFixed(2)}
            label={`Ast to TO`}
        />
    ) : ''

    const title = (
        <Box display="flex" flexDirection="column" mb={3}>
            <Grid xs={12} container item display="flex" justifyContent="center" mt={2}>
                <Typography
                    variant="h6"
                    align="center"
                    sx={{ wordWrap: "break-word", whiteSpace: "normal" }}
                >
                    {formattedStringTitle}
                </Typography>
            </Grid>
            <br />
            <GameInfoToolTipRow
                teamValue={`${game.school || game.team} (${game.wins} - ${game.losses})`}
                oppValue={`${game.oSchool || game.oTeam} (${game.oWins} - ${game.oLosses})`}
                label={` `}
            />
            <GameInfoToolTipRow
                teamValue={`${game.division || game.conference} ${game.division ? 'Div.' : 'Conf.'}`}
                oppValue={`${game.oDivision || game.oConference} ${game.division ? 'Div.' : 'Conf.'}`}
                label={` `}
            />
            {typeof game.rest === 'number' ?
                <GameInfoToolTipRow
                    teamValue={rest}
                    oppValue={oRest}
                    label={` `}
                /> : ''
            }

            <br/>
            <GameInfoToolTipRow
                teamValue={' '}
                oppValue={' '}
                label={`Season Avgs`}
            />
            <GameInfoToolTipRow
                teamValue={`${game.avgPoints?.toFixed(1)} - ${game.avgOPoints?.toFixed(1)}`}
                oppValue={`${game.oppAvgPoints?.toFixed(1)} - ${game.oppAvgOPoints?.toFixed(1)}`}
                label={`Score`}
            />
            <GameInfoToolTipRow
                teamValue={game.avgRest?.toFixed(2)}
                oppValue={game.oppAvgRest?.toFixed(2)}
                label={`Rest`}
            />
            {assistToTurnover}
            <br/>
            <GameInfoToolTipRow
                teamValue={` `}
                oppValue={` `}
                label={`Betting`}
            />
            <GameInfoToolTipRow
                teamValue={game.avgAtsMargin}
                oppValue={game.oppAvgAtsMargin}
                label={`ATS Cover %`}
            />
            <GameInfoToolTipRow
                teamValue={game.avgOuMargin}
                oppValue={game.oppAvgOuMargin}
                label={`OV/UN %`}
            />
            <br/>
            <GameInfoToolTipRow
                teamValue={' '}
                oppValue={' '}
                label={`Streaks`}
            />
            <GameInfoToolTipRow
                teamValue={game.streak?.toString()}
                oppValue={game.oStreak?.toString()}
                label={`Win`}
            />
            <GameInfoToolTipRow
                teamValue={game.atsStreak?.toString()}
                oppValue={game.oAtsStreak?.toString()}
                label={`ATS`}
            />
            <GameInfoToolTipRow
                teamValue={game.ouStreak?.toString()}
                oppValue={game.oOuStreak?.toString()}
                label={`OV-UN`}
            />
        </Box>
    );



    return (
        <Tooltip
            title={title}
            placement="right"
            PopperProps={getPopperProps(isMobile)}
            disableHoverListener={isMobile}
        >
            <IconButton size="small">
                <Info
                    sx={{
                        fontSize: "11pt",
                        color: theme.palette.grey[500],
                    }}
                />
            </IconButton>
        </Tooltip>
    );
};